var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { classNames, Flex, toKebabCase } from '@tpr/core';
import styles from './input.module.scss';
export var Input = function (_a) {
    var _b;
    var id = _a.id, _c = _a.type, type = _c === void 0 ? 'text' : _c, width = _a.width, testId = _a.testId, name = _a.name, label = _a.label, _d = _a.isError, isError = _d === void 0 ? false : _d, className = _a.className, readOnly = _a.readOnly, After = _a.after, Before = _a.before, decimalPlaces = _a.decimalPlaces, parentRef = _a.parentRef, ariaLabelExtension = _a.ariaLabelExtension, accessibilityHelper = _a.accessibilityHelper, rest = __rest(_a, ["id", "type", "width", "testId", "name", "label", "isError", "className", "readOnly", "after", "before", "decimalPlaces", "parentRef", "ariaLabelExtension", "accessibilityHelper"]);
    var getAriaLabel = function () {
        var _a;
        var ariaLabel = (_a = rest['aria-label']) !== null && _a !== void 0 ? _a : label;
        if (!ariaLabelExtension) {
            return ariaLabel;
        }
        if (/^[a-z0-9]/i.test(ariaLabelExtension)) {
            ariaLabel = ariaLabel + ' ';
        }
        return "" + ariaLabel + ariaLabelExtension;
    };
    return (React.createElement(Flex, { cfg: { flex: width ? '0 0 auto' : '1 1 auto', width: width }, className: After ? styles['input-wrapper_relative'] : '' },
        Before && (React.createElement("span", { className: styles.before, id: name && toKebabCase(name) + '-before', "aria-label": Before.match('£') ? 'in pounds' : '' }, Before)),
        React.createElement("input", __assign({ id: id, ref: parentRef, type: type, "data-testid": testId, readOnly: readOnly, step: type !== 'number'
                ? null
                : decimalPlaces
                    ? Math.pow(10, -decimalPlaces)
                    : 1, className: classNames([
                styles.inputText,
                className,
                (_b = {},
                    _b[styles['inputText-error']] = isError,
                    _b),
            ]), "aria-invalid": !!isError, "aria-describedby": accessibilityHelper &&
                accessibilityHelper.formatAriaDescribedBy(isError) }, rest, { name: name, "aria-label": getAriaLabel() })),
        After && (React.createElement("span", { className: styles.after, id: name && toKebabCase(name) + '-after' }, After))));
};
//# sourceMappingURL=input.js.map